function initCommentForm() {
  const form = document.querySelector('.js-comment-form');
  if (!form) return;

  const disableClassArray = ['opacity-50', 'cursor-not-allowed'];

  form.addEventListener('submit', (e) => {
    const btn = form.querySelector('[type="submit"]');
    if (!btn) return;

    const loadingText = btn.getAttribute('data-loading-text');

    btn.disabled = true;
    btn.classList.add(...disableClassArray);
    btn.textContent = loadingText;
  });
}

export {initCommentForm};
